/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlColor } from './ControlColor';
import {
    ControlColorFromJSON,
    ControlColorFromJSONTyped,
    ControlColorToJSON,
} from './ControlColor';

/**
 * 
 * @export
 * @interface ControlDirectoryUserGroupCount
 */
export interface ControlDirectoryUserGroupCount {
    /**
     * 
     * @type {ControlColor}
     * @memberof ControlDirectoryUserGroupCount
     */
    color: ControlColor;
    /**
     * 
     * @type {number}
     * @memberof ControlDirectoryUserGroupCount
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUserGroupCount
     */
    groupId: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUserGroupCount
     */
    name: string;
}

/**
 * Check if a given object implements the ControlDirectoryUserGroupCount interface.
 */
export function instanceOfControlDirectoryUserGroupCount(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "color" in value;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "groupId" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function ControlDirectoryUserGroupCountFromJSON(json: any): ControlDirectoryUserGroupCount {
    return ControlDirectoryUserGroupCountFromJSONTyped(json, false);
}

export function ControlDirectoryUserGroupCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlDirectoryUserGroupCount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'color': ControlColorFromJSON(json['color']),
        'count': json['count'],
        'groupId': json['groupId'],
        'name': json['name'],
    };
}

export function ControlDirectoryUserGroupCountToJSON(value?: ControlDirectoryUserGroupCount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'color': ControlColorToJSON(value.color),
        'count': value.count,
        'groupId': value.groupId,
        'name': value.name,
    };
}

